import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CrossShape",
  "use": "svg-icon-CrossShape-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"svg-icon-CrossShape\"><path fill-rule=\"evenodd\" d=\"M10.243.343L6 4.586 1.757.343.343 1.757 4.586 6 .343 10.243l1.414 1.414L6 7.414l4.243 4.243 1.414-1.414L7.414 6l4.243-4.243z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol